/**
 * Délai avant de libérer l'URL d'un blob téléchargé. Safari lit le blob APRÈS
 * le `click()` : libérer l'URL tout de suite annulait le téléchargement sur
 * iPhone (audit mobile 2026-10-22, même cause que `CanvasDownloadMenu`).
 * Source : FileSaver.js libère après 40 s,
 * https://github.com/eligrey/FileSaver.js/blob/master/src/FileSaver.js (vérifié 2026-10-22)
 */
const BLOB_URL_RELEASE_DELAY_MS = 40_000;

/**
 * Triggers a browser download from a Blob. Seul chemin de téléchargement d'un
 * blob : ne pas recopier `createObjectURL` + `click()` ailleurs.
 */
export function triggerBlobDownload(blob: Blob, fileName: string): void {
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = fileName;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  window.setTimeout(() => window.URL.revokeObjectURL(url), BLOB_URL_RELEASE_DELAY_MS);
}
